import axios from "axios";
import { notifications } from "@mantine/notifications";

const appAxios = axios.create({
  headers: { "X-Site-Version": "0.3.1" },
});

export const showErrorNotification = (error) => {
  let message = "An unexpected error occurred";

  if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.message
  ) {
    message = error.response.data.message;
  } else if (
    error &&
    error.response &&
    error.response.data &&
    error.response.data.error
  ) {
    message = error.response.data.error;
  } else if (error && error.message) {
    message = error.message;
  } else if (typeof error === "string") {
    message = error;
  }

  notifications.show({
    title: "Error",
    message,
    color: "red",
    autoClose: 5000,
  });
};

export default appAxios;
